import { Contact } from "@/components/jobs/SubmitJob";
import { SUBMIT_JOB_CONTENT } from "@/constants/jobConstants";
import { createSlice } from "@reduxjs/toolkit";

const initialState: Record<string, number | string | boolean | Array<Contact>> = {
  // Job Profile details
  publishing: "",
  contacts: [],
  dryRun: "",
  // Component only: "YES"/"NO" for "Is this an MCP Server?" (YES sends ImageInfo.Category = MCP_SERVER).
  isMcpServer: "",
  yml: "NO",
  incrementalUpdate: "",
  ymlFile: "",
  jobType: "",
  release: "",
  imageType: "",
  platform: "",
  sourceRoot: "",
  sourcePath: "",
  plc: "",
  parentJobProfile: "",
  channel: "",
  subChannel: "",
  tag: "",
  // Transient: raw JobInfo.Channel captured from an uploaded YAML or an existing
  // job before the profile has loaded. Resolved into channel + subChannel and
  // cleared once ItemInfo can split it (see resolveChannelSelection).
  pendingChannel: "",
  // Resolved build type ("di"/"db"/"ds") from the selected profile/channel, for publishing
  // types whose Output.Type would otherwise be hardcoded (see NON_BUNDLE_PUBLISHING_TYPES).
  channelJobTypeOverride: "",
  // Selected channel's Publish.JobType (serializeProfileJobTypes, e.g. "di,db,dbPreBuilt"); enables
  // Install / Download / Component Path in Image Info. "" = not profile-constrained.
  profileJobTypes: "",
  displayName: "",
  country: "USA",
  language: "en-US",
  partNumber: "",
  sapDescription: "",
  teamName: "",
  imageFileName: "",
  jobTitle: "",
  imageSize: "",
  productDISelect: true,
  productDBSelect: true,
  dirtyOutputImageName: false,
  s3bucket: "",
  s3key: "",
  compressed: false,
  rootUPI: "",
  outputPath: "",
  dirtyOutputPathName: false,
  componentPath: "",
  rootManifestPath: "",
  component_update_mode: "",
  componentUPI2: "",
  componentExist: false,
  editJobId: "",
  targetDomain: "",
  uploadingToS3: false,
  odisOnboarded: true
};

const submitJobSlice = createSlice({
  name: "submitJob",
  initialState: initialState,
  reducers: {
    updateSubmitJobDetails: (state, action: { payload: { key: string; value: string | boolean } }) => {
      state[action.payload.key] = action.payload.value;
    },
    updateSubmitJobBulk: (state, action: { payload: Record<string, string | boolean | number> }) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        state[key] = value;
      });
    },
    updateSubmitJobContactDetails: (state, action: { payload: Array<Contact> }) => {
      state.contacts = action.payload;
    },
    resetSubmitJob: (): Record<string, number | string | boolean | Array<Contact>> => {
      return {
        ...initialState,
        country: SUBMIT_JOB_CONTENT.defaultCountry,
        language: SUBMIT_JOB_CONTENT.defaultLanguage
      };
    },
    unloadYamlFile: (state, action: { payload: Contact }) => {
      return {
        ...initialState,
        publishing: state.publishing,
        isMcpServer: state.isMcpServer,
        yml: state.yml,
        contacts: [action.payload]
      };
    }
  }
});

export const { updateSubmitJobDetails, updateSubmitJobBulk, updateSubmitJobContactDetails, resetSubmitJob, unloadYamlFile } = submitJobSlice.actions;

export default submitJobSlice.reducer;
